import React, { useEffect, useState } from "react";
import { Search } from "react-feather";
import { getBulkDropdownData, getDropdownData } from "../../api/keyvalue";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import Button from "../input/Button";
import {
  searchUserCustomerGroup,
  userCustomerGroupDropdown,
} from "../../api/UserCustomerApi";

const UserCustomerGroupSearch = ({
  setSearchClicked,
  setSearchSubmitLoading,
  setSearchResults,
  setFetchLoading,
  onRowDoubleClick,
}) => {
  const [groupName, setGroupName] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const [accordionOpen, setAccordionOpen] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);

  useEffect(() => {
    (async () => {
      //new

      const { status, active } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
      ]);

      setStatusOptions(status);
      setActiveOptions(active);
    })();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setSearchClicked(true);
    setSearchSubmitLoading(true);
    setResetVisible(true);

    const response = await searchUserCustomerGroup({
      groupName,
      ucgStatus: status,
      ucgActive: active,
    });

    setSearchResults(response.data);
    setSearchSubmitLoading(false);
  };

    const handleReset = () => {
        setGroupName("");
        setStatus(2);
        setActive(1);
        setResetVisible(false);
    };

  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${accordionOpen ? "active" : ""}`}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span>Search</span>
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
            {resetVisible && (
              <i
                className="refresh icon primary button"
                onClick={handleReset}
                style={{ cursor: "pointer" }}
              ></i>
            )}
          </div>
        </div>
        <div className={`content ${accordionOpen ? "active" : ""}`}>
          <form className="ui form">
            <div className="ui dividing header"></div>
            <div className="three fields">
              <Input
                label="Group Name"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
              <Dropdown
                label="Status"
                options={statusOptions}
                value={status}
                onChange={(e, data) => setStatus(data.value)}
                placeholder="Status"
              />
              <Dropdown
                label="Active"
                options={activeOptions}
                value={active}
                onChange={(e, data) => setActive(data.value)}
                placeholder="Active"
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button template="searchReset" onClick={handleReset} />
              <Button template="search" onClick={handleSearch} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserCustomerGroupSearch;
